@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 1s cubic-bezier(0.75, 0.275, 0.19, 0.74) infinite;
}
